const PLAY_URL = "https://play.google.com/store/apps/details?id=in.getfetcher.app";
const APP_STORE_URL = "https://apps.apple.com/in/app/fetcher-anything-delivered/id6809124998";

export const PlayBadge = ({ testId = "google-play-badge" }) => (
  <a
    href={PLAY_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className="group inline-block transition-transform duration-300 hover:-translate-y-0.5"
  >
    <img
      src="/google-play-badge.png"
      alt="Get it on Google Play"
      width="216"
      height="64"
      className="h-14 w-auto drop-shadow-[0_10px_30px_rgba(0,0,0,0.25)]"
    />
  </a>
);

export const AppStoreBadge = ({ testId = "app-store-badge" }) => (
  <a
    href={APP_STORE_URL}
    target={APP_STORE_URL === "#" ? undefined : "_blank"}
    rel="noopener noreferrer"
    data-testid={testId}
    className="group inline-block transition-transform duration-300 hover:-translate-y-0.5"
  >
    <img
      src="/app-store-badge.png"
      alt="Download on the App Store"
      width="216"
      height="64"
      className="h-14 w-auto drop-shadow-[0_10px_30px_rgba(0,0,0,0.25)]"
    />
  </a>
);

// Both store badges side by side.
export const StoreBadges = ({ prefix = "hero" }) => (
  <div className="flex flex-wrap items-center gap-3">
    <AppStoreBadge testId={`${prefix}-app-store-badge`} />
    <PlayBadge testId={`${prefix}-play-badge`} />
  </div>
);

export { PLAY_URL, APP_STORE_URL };
